<div fxLayout="column" *ngIf="!job">
  <h3 style="margin-top: 0 !important;" >Przetwarzanie zapytania...</h3>
  <div fxFlex="100" fxLayout="row">
    <mat-progress-spinner style="margin:0 auto;" mode="indeterminate"></mat-progress-spinner>
  </div>

</div>
<div fxLayout="column"  *ngIf="job && runClosed">
  <mat-progress-bar *ngIf="!jobObject.exitCode" [color]="color" [mode]="mode"></mat-progress-bar>
  <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
    <h3 *ngIf="jobObject.exitCode === null">Weryfikacja rozliczeń ... </h3>
    <h3 *ngIf="jobObject.parameters[0]?.item?.checkClosed && jobObject.exitCode === 200">Weryfikacja przeszła pomyślnie</h3>
    <h3 *ngIf="jobObject.exitCode === 500">Wystąpił błąd weryfikacji</h3>
    <ng-container *ngIf="!jobObject.parameters[0]?.item?.checkClosed && jobObject?.exitCode">
      <div fxFlex="100" fxLayout="row">
        <h3>Nie można zamknąć miesiąca rozliczeniowego. <br>Zweryfikuj poniższe błędy.</h3>
      </div>
    </ng-container>


  </div>
  <ng-container *ngIf="showErrors">
    <div fxFlex="100" fxLayout="row" fxLayoutGap="15px">
      <ng-container *ngFor="let item of jobObject.parameters; let last = last">
          <span fxLayout="row" fxLayoutGap="15px" class="small">{{item.key}}<ng-container *ngIf="item.key">:</ng-container> {{item.value}}</span>
      </ng-container>
    </div>
    <ng-container *ngIf="!jobObject.parameters[0]?.item?.checkClosed && jobObject?.exitCode">
    <ng-container *ngFor="let item of jobObject.parameters; let last = last">
      <ng-container *ngIf="item.policeCount > 0">
        <app-detail fxFlex="100" header="Polisy w statusie nowa">
          <ng-container *ngFor="let items of item.policeArray; let last = last">
            <ng-container *ngIf="items.statusCommissionImportRow === COMMISSION_SETTLEMENT_STATUS_NEW">
                <a target="_blank" class="default-link" [routerLink]="items?.importRow ? ['/raporty-tu/prowizje/szczegoly/', items?.importRow] : undefined">{{items.policyNumber ? items.policyNumber : 'brak numeru polisy'}}</a>
                <ng-container *ngIf="!last">, </ng-container>
            </ng-container>
          </ng-container>
        </app-detail>
      </ng-container>
      <ng-container *ngIf="item.policeCount > 0">
        <app-detail fxFlex="100" header="Polisa niepodpięta pod żadne rozliczenie">
          <ng-container *ngFor="let items of item.policeArray; let last = last">
            <ng-container *ngIf="items.settlement === null">
                <a target="_blank" class="default-link" [routerLink]="items?.importRow ? ['/raporty-tu/prowizje/szczegoly/', items?.importRow] : undefined">{{items.policyNumber ? items.policyNumber : 'brak numeru polisy'}}</a>
                <ng-container *ngIf="!last">, </ng-container>
            </ng-container>
          </ng-container>
        </app-detail>
      </ng-container>
      <ng-container *ngIf="item.settlementCount > 0">
        <app-detail fxFlex="100" header="Rozliczenie w statusie do wygenerowania">
          <ng-container *ngFor="let settlement of item.settlementArray; let last = last">
            <ng-container  *ngIf="settlement.uuid">
              <a target="_blank" class="default-link" [routerLink]="settlement.uuid ? ['/rozliczenia/szczegoly/', settlement?.uuid] : undefined">{{settlement?.shortName}}</a>
                <ng-container *ngIf="!last">, </ng-container>
            </ng-container>
          </ng-container>
        </app-detail>
      </ng-container>
      <ng-container *ngIf="item.policeCount > 0">
        <app-detail fxFlex="100" header="Błąd polisy">
          <ng-container *ngFor="let items of item.policeArray; let last = last">
            <ng-container *ngIf="items.contractOwner === null">
              <a target="_blank" class="default-link" [routerLink]="items?.importRow ? ['/raporty-tu/prowizje/szczegoly/', items?.importRow] : undefined">{{items.policyNumber ? items.policyNumber : 'brak numeru polisy'}}</a>
              <ng-container *ngIf="!last">, </ng-container>
            </ng-container>
          </ng-container>
        </app-detail>
      </ng-container>
    </ng-container>
  </ng-container>
  </ng-container>
</div>
<div fxLayout="column" *ngIf="job && (checkSettlement || checkSettlementButton) && !runClosed">
  <mat-progress-bar *ngIf="!jobObject.exitCode" [color]="color" [mode]="mode"></mat-progress-bar>
  <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
    <h3 *ngIf="jobObject.exitCode === null">Weryfikacja rozliczeń</h3>
    <h3 *ngIf="jobObject.exitCode === 200">Weryfikacja przeszła pomyślnie</h3>
    <h3 *ngIf="jobObject.exitCode === 500">Wystąpił błąd weryfikacji</h3>
  </div>
  <div fxFlex="100" fxLayout="row" fxLayoutGap="15px">
    <ng-container *ngFor="let item of jobObject.parameters; let last = last">
      <span fxLayout="row" fxLayoutGap="15px" class="small">{{item.key}}<ng-container *ngIf="item.key">:</ng-container> {{item.value}}  <ng-container *ngIf="item.settlementArray?.length > 0"> Znaleziono: {{item.settlementArray?.length}}</ng-container> </span>
    </ng-container>
  </div>
    <ng-container *ngFor="let item of jobObject.parameters; let last = last">
      <ng-container *ngIf="(item?.settlementArray?.length > 0 || item?.settlementContractTypCount > 0 || item?.settlementContractCount > 0) && jobObject?.exitCode">
        <div fxLayout="row" fxFlex="100">
          <h3 *ngIf="checkSettlementButton">Znaleziono błędy w rozliczeniu, czy na pewno chcesz zamknąć miesiąc?</h3>
        </div>
        <ng-container *ngIf="item?.settlementArray.length > 0">
          <div fxLayout="row" fxFlex="100">
            <h3  class="color-primary"> Umowa w polisach różni się od umowy, której dotyczy rozliczenie</h3>
          </div>
          <div fxLayout="row" class="flexRow">
            <ng-container *ngFor="let items of item?.settlementArray; let last = last">
              <a target="_blank" class="default-link color-primary" [routerLink]="items.uuid ? ['/rozliczenia/szczegoly/', items.uuid] : undefined">{{items.name}} ({{items.number}})</a> <ng-container *ngIf="!last">,</ng-container>
            </ng-container>
          </div>
        </ng-container >
        <ng-container *ngIf="item?.settlementContractTypCount > 0">
          <div fxLayout="row" fxFlex="100">
            <h3  class="color-primary"> Rozliczenie podpięte pod inny typ umowy niż: współpracy, profitowi, zlecenie. </h3>
          </div>
          <div fxLayout="row" class="flexRow">
            <ng-container *ngFor="let items of item?.settlementContractTyp; let last = last">
              <a target="_blank" class="default-link color-primary" [routerLink]="items.uuid ? ['/rozliczenia/szczegoly/', items.uuid] : undefined">{{items.name}} ({{items.number}})</a> <ng-container *ngIf="!last">,</ng-container>
            </ng-container>
          </div>
        </ng-container >
        <ng-container *ngIf="item?.settlementContractCount > 0">
          <div fxLayout="row" fxFlex="100">
           <h3  class="color-primary"> Partner posiada więcej niż jedno rozliczenie w danej firmie. </h3>
          </div>
          <div fxLayout="row" class="flexRow">
          <ng-container *ngFor="let items of item?.settlementContract; let last = last">
            <a target="_blank" class="default-link color-primary" [routerLink]="items.uuid ? ['/rozliczenia/szczegoly/', items.uuid] : undefined">{{items.name}} ({{items.number}})</a> <ng-container *ngIf="!last">,</ng-container>
          </ng-container>
          </div>
        </ng-container >
        <div fxLayout="row" fxFlex="100">&nbsp;</div>
        <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" *ngIf="checkSettlementButton">
          <div fxFlex></div>
          <button (click)="closeDialogRef()" mat-raised-button color="warn"><span> Tak</span></button>
          <button (click)="decline()" mat-raised-button color="primary" class="confirm-dialog-decline-button"><span> Nie</span></button>
        </div>
      </ng-container>
  </ng-container>
</div>
